import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTable: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"table, spreedsheet, chart"} maskId="square-filled-radius-0-stroke-1-IconTable"><path d="M10 3H21V9H10V3Z" fill="currentColor"/><path d="M9 3H3V9H9V3Z" fill="currentColor"/><path d="M3 10V21H9V10H3Z" fill="currentColor"/><path d="M10 21H21V10H10V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTable;
